import * as React from 'react'
import { Box, Tooltip } from '@mui/material'
import WifiIcon from '@mui/icons-material/Wifi'
import WifiOffIcon from '@mui/icons-material/WifiOff'
import SignalWifiStatusbarConnectedNoInternet4Icon from '@mui/icons-material/SignalWifiStatusbarConnectedNoInternet4'
import { useConnectionContext } from './ConnectionContext'

export default function ConnectionIndicator() {
	const { connectionStatus } = useConnectionContext()

	const getConnectionIcon = () => {
		switch (connectionStatus) {
			case 'online':
				return <WifiIcon sx={{ color: 'success.main' }} />
			case 'offline':
				return <WifiOffIcon sx={{ color: 'error.main' }} />
			case 'limited':
				return <SignalWifiStatusbarConnectedNoInternet4Icon sx={{ color: 'warning.main' }} />
			default:
				return <WifiIcon sx={{ color: 'grey.500' }} />
		}
	}

	const getConnectionTooltip = () => {
		switch (connectionStatus) {
			case 'online':
				return 'Connected to internet'
			case 'offline':
				return 'No internet connection'
			case 'limited':
				return 'Limited internet connection'
			default:
				return 'Checking connection...'
		}
	}

	return (
		<Tooltip title={getConnectionTooltip()} arrow>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					marginLeft: '10px',
					cursor: 'default',
				}}
			>
				{getConnectionIcon()}
			</Box>
		</Tooltip>
	)
}
